// @ts-nocheck
import useDispatchSetInput from "@store/Framework/Store/Foundation/Components/Form/FormHooks/useDispatchSetInput";
import { InputModel } from "@store/Framework/Store/Foundation/Components/Form/FormTypes";
import { FormContext } from "@store/Library/Components/Foundation/StoreForm/StoreFormContextProvider";
import { useContext } from "react";

export default () => {
    const form = useContext(FormContext);
    const dispatchSetInput = useDispatchSetInput();

    const setForm = (input: InputModel) => {
        dispatchSetInput(form.id, input);
    };

    return { form, setForm };
};
